
import { defuFn } from '/home/runner/work/help-centre/help-centre/node_modules/nuxt/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
